module.exports = __webpack_public_path__ + "59fc19382f688442b1eb20a9569fad1f.png";